module.exports = __webpack_public_path__ + "img/ski_place6.24c46ef0.png";